(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-reviews"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
   var star_rating_width = $('.fill-ratings span').width();
   $('.star-ratings').width(star_rating_width);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews-carousel"]) return;
  try {
    
  $(document).ready(function() {
   var star_rating_width = $('.fill-ratings span').width();
   $('.star-ratings').width(star_rating_width);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
$(function(){
  if($(".product-info-slider").length > 0) {
    $(".product-info-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      dots: false,
      arrows: true
    }); 
  }
  let findOptions = setInterval(function(){
    if($(".webyze-infinitelivepreviewoptions-form").length > 0) {
      $(".webyze-infinitelivepreviewoptions-form .webyze-ilpo-option").each(function(ind){
        $(this).addClass("option-"+(ind+1));
        if(ind > 0) {
          $(this).addClass("no-color-swatch"); 
        }
      });
      //clearInterval(findOptions);
    }
  }, 1000);
  $(document).on("click", ".qty-wrap button", function(){
    let qty = parseInt($(this).parent().find(".quantity-selector").val());
    if($(this).hasClass("qty-dec")) {
      if(qty > 1) {
        qty = qty - 1;
      }
    }
    else {
      qty = qty + 1;
    }
    $(this).parent().find(".quantity-selector").val(qty); 
  });
  $(document).on("click", ".description-expandable .show-full-desc", function(e){
    e.preventDefault();
    $(".description-expandable .short-desc").stop().slideToggle();
    $(".description-expandable .full-desc").stop().slideToggle();
  });
  $(document).on("click", ".specs-section .acc-block button", function(e){
    e.preventDefault();
    if(!$(this).parent().parent(".acc-block").hasClass("active")) {
      $(".specs-section .acc-block .acc-desc").stop().slideUp();
      $(".specs-section .acc-block").removeClass("active");
      $(this).parent().next(".acc-desc").stop().slideToggle();
      $(this).parent().parent(".acc-block").addClass("active");
    }
    else {
      $(this).parent().next(".acc-desc").stop().slideUp();
      $(this).parent().parent(".acc-block").removeClass("active");
    } 
  }); 
  $(document).on("click", ".info-accordion-section .acc-block button", function(e){
    e.preventDefault();
    if(!$(this).parent().parent(".acc-block").hasClass("active")) {
      $(".info-accordion-section .acc-block .acc-desc").stop().slideUp();
      $(".info-accordion-section .acc-block").removeClass("active");
      $(this).parent().next(".acc-desc").stop().slideToggle();
      $(this).parent().parent(".acc-block").addClass("active");
    }
    else {
      $(this).parent().next(".acc-desc").stop().slideUp();
      $(this).parent().parent(".acc-block").removeClass("active");
    }
  });

  let pro_selector = setInterval(()=>{
    if($(".webyze-infinitelivepreviewoptions-form").length > 0 && $(".product-selectors .webyze-infinitelivepreviewoptions-form").length < 1) {
      $(".webyze-infinitelivepreviewoptions-form").prependTo(".product-selectors");
      console.log("Prepended product selectors");
      clearInterval(pro_selector);
    }
  }, 500);
});

  } catch(e) { console.error(e); }
})();
})();
